import styled from 'styled-components';
export var ResultHeading = styled.li.withConfig({
  displayName: "ResultHeading",
  componentId: "sc-t7rqm7-0"
})(["position:relative;padding:5px 42px 7px 0;font-weight:400;color:", ";&:before{position:absolute;z-index:-1;top:0;bottom:0;left:-9px;right:-9px;content:'';background-color:", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.font;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.uiLL;
});
export var CloseSuggestions = styled.div.withConfig({
  displayName: "ResultHeading__CloseSuggestions",
  componentId: "sc-t7rqm7-1"
})(["position:absolute;top:0;right:0;width:36px;height:36px;cursor:pointer;text-align:center;svg{position:relative;top:9px;}"]);